import React, { useCallback, useEffect, useState } from 'react';
import { Layers, Sparkles } from 'lucide-react';
import { Button, Modal } from '../Exploration/ui';
import { programmesApi, useProgrammeAccess } from './api';
import { Suggestion } from './ProgrammeChip';

// Sur la liste des projets : les regroupements que Nexus propose (chaque nuit, ou à la demande depuis un projet).
// Accepter crée le programme (on peut corriger le nom et décocher des projets) ; ignorer ne le repropose plus.

export default function SuggestionsBanner({ onOpenProject }) {
  const { access } = useProgrammeAccess();
  const [suggestions, setSuggestions] = useState([]);
  const [open, setOpen] = useState(false);
  const [created, setCreated] = useState(null);
  const load = useCallback(async () => {
    try { setSuggestions((await programmesApi.list()).suggestions || []); } catch { setSuggestions([]); }
  }, []);
  useEffect(() => { if (access) load(); }, [access, load]);
  if (!access || (!suggestions.length && !created)) return null;
  return (
    <div className="mb-4 flex flex-wrap items-center gap-2 rounded-xl border border-indigo-100 bg-indigo-50/60 px-3 py-2 text-sm text-indigo-900">
      <Sparkles size={16} className="shrink-0 text-indigo-500" />
      {suggestions.length > 0 ? (
        <span className="min-w-0 flex-1">
          Nexus propose de réunir des projets en programmes (les étapes d’un même effort) : {suggestions.slice(0, 3).map((s) => `${s.name} (${s.projects.length})`).join(', ')}{suggestions.length > 3 ? '…' : ''}
        </span>
      ) : (
        <span className="min-w-0 flex-1">Programme « {created.name} » créé : son onglet Programme est sur chacun de ses projets.</span>
      )}
      {suggestions.length > 0 && <Button size="xs" variant="nexus" icon={Layers} onClick={() => setOpen(true)}>Voir</Button>}
      {created && <Button size="xs" variant="ghost" onClick={() => onOpenProject(created.projects[0].id)}>Ouvrir</Button>}
      {open && (
        <Modal open onClose={() => setOpen(false)} title="Programmes proposés par Nexus" width="max-w-xl"
          footer={<Button variant="ghost" onClick={() => setOpen(false)}>Fermer</Button>}>
          <div className="space-y-3">
            {suggestions.map((s) => (
              <Suggestion key={s.id} suggestion={s} projectId={null}
                onDone={async (ok) => {
                  if (ok) setCreated({ name: s.name, projects: s.projects });
                  await load();
                }} />
            ))}
            {suggestions.length === 0 && <p className="text-sm text-slate-500">Plus rien à valider.</p>}
          </div>
        </Modal>
      )}
    </div>
  );
}
